import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { IAppointment } from 'src/app/shared/interfaces/appointment';
import { IDisease } from 'src/app/shared/interfaces/disease';
import { EDiseaseType } from 'src/app/shared/interfaces/diseaseType-enum';
import { EGender } from 'src/app/shared/interfaces/gender-enum';
import { IUser } from 'src/app/shared/interfaces/user';
import { FakeDataService } from 'src/app/shared/mock/fake-data.service';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-account-info',
  templateUrl: './account-info.component.html',
  styleUrl: './account-info.component.css'
})
export class AccountInfoComponent implements OnInit {

  heartDis: boolean = false;
  lungDis: boolean = false;
  genderType = EGender;
  diseaseType = EDiseaseType;
  allDisease: IDisease[] = [];
  allSurgery: IDisease[] = [];
  selectedDiseases: number[] = [];
  userInfo: IUser = {
    id: 0,
    userInfoId: 0,
    firstName: '',
    lastName: '',
    mobile: '',
    mail: '',
    status: 0, //enum
    idNo: '',
    birthDate: 0, //date time
    isMale: true,
    education: '',
    job: '',
    country: '',
    state: '',
    city: '',
    zipCode: '',
    address: '',
    smsCode: '',
    lastDrug: '',
    lastAllergy : '',
    skyRoomPassword: '',
    gender: 0, //Gender
    skyRoomUserId: 0,
    photoFileName: '',
    IsActiveOnlineVisit: false,
    IsActiveAttendanceVisit: false,
    userDiseases: []
    // userDiseases: [
    //   {
    //     id: 0,
    //     titleFa: 'دیابت',
    //     titleEn: '',
    //     description: '',
    //     diseaseType: 1
    //   }, 
    //   {
    //     id: 0,
    //     titleFa: 'کم کاری تیروئید',
    //     titleEn: '',
    //     description: '',
    //     diseaseType: 1
    //   }, 
    //   {
    //     id: 0,
    //     titleFa: 'پر کاری تیروئید',
    //     titleEn: '',
    //     description: '',
    //     diseaseType: 1
    //   }, 
    //   {
    //     id: 0,
    //     titleFa: 'چربی خون',
    //     titleEn: '',
    //     description: '',
    //     diseaseType: 1
    //   }, 
    //   {
    //     id: 0,
    //     titleFa: 'فشار خون بالا',
    //     titleEn: '',
    //     description: '',
    //     diseaseType: 1
    //   }, 
    //   {
    //     id: 0,
    //     titleFa: 'فشار خون پایین',
    //     titleEn: '',
    //     description: '',
    //     diseaseType: 1
    //   }, 
    //   {
    //     id: 0,
    //     titleFa: 'بیماری روماتیسمی',
    //     titleEn: '',
    //     description: '',
    //     diseaseType: 1
    //   }, 
    //   {
    //     id: 0,
    //     titleFa: 'بیماری قلبی',
    //     titleEn: '',
    //     description: '',
    //     diseaseType: 1
    //   }, 
    //   {
    //     id: 0,
    //     titleFa: 'بیماری ریوی',
    //     titleEn: '',
    //     description: '',
    //     diseaseType: 1
    //   }, 
    //   {
    //     id: 0,
    //     titleFa: 'جراحی قلب',
    //     titleEn: '',
    //     description: '',
    //     diseaseType: 2
    //   }, 
    //   {
    //     id: 0,
    //     titleFa: 'برداشتن کیسه صفرا',
    //     titleEn: '',
    //     description: '',
    //     diseaseType: 2
    //   }, 
    //   {
    //     id: 0,
    //     titleFa: 'برداشتن رحم',
    //     titleEn: '',
    //     description: '',
    //     diseaseType: 2
    //   }, 
    //   {
    //     id: 0,
    //     titleFa: 'برداشتن روده',
    //     titleEn: '',
    //     description: '',
    //     diseaseType: 2
    //   }
    // ]
    
  };

  constructor(private apiService: ApiService,
    private messageService: MessageService
  ){}


  ngOnInit(): void {
    
    this.getUserInfo();
    // this.getAllDisease();
  }

  getUserInfo() {
    this.apiService.apiCall('get', '/api/User/Detail').subscribe((res: any) => {
      console.log(res);
      
      this.userInfo = res.body.model;
      this.getAllDisease();
    })
  }

  updateUserInfo() {
    console.log(this.userInfo);
    
    this.apiService.apiCall('post', '/api/User/Edit', this.userInfo).subscribe((res: any) => {
      console.log(res);
      
      if (res.body.isSuccess == true) {

        this.messageService.add({severity: 'success', summary: 'موفق', detail: ' ویرایش اطلاعات با موفقیت انجام شد' });
      } else {
        this.messageService.add({severity: 'error', summary: 'خطا', detail: res.body.message});
      }
    })
  }

  onCheckboxChange(item, event) {
    if (event.target.checked) {
      this.userInfo.userDiseases.push(item);
    } else {
      this.userInfo.userDiseases = this.userInfo.userDiseases.filter(diseaseId => diseaseId !== item.id);
    }
  }

  // addUserDisease(event: any, dis: IDisease) {
  //   console.log(event);

  //   if(event.target.checked){
  //     this.userInfo.userDiseases.push(dis);
  //   }
    
  // }

  getAllDisease() {
    this.apiService.apiCall('get', '/api/User/AllDisease').subscribe((res: any) => {
      console.log(res);
      
      // this.userInfo.userDiseases = res.body.model;
      res.body.model.forEach(element => {
        if (element.diseaseType==this.diseaseType.disease){
          this.allDisease.push(element)
        } else if (element.diseaseType==this.diseaseType.surgury) {
          this.allSurgery.push(element)
        }
      });
      
      this.selectedDiseases = this.userInfo.userDiseases.map(d => d.id);

      // Add age property to each object
      // this.allDisease = this.allDisease.map(dis => ({
      //   ...dis, // spread existing properties
      //   checked: false  // add new property
      // }));

      // this.allDisease.forEach(all => {
      //   this.userInfo.userDiseases.forEach(user => {
          
      //     if (all.id == user.id) {
      //       all.checked = true;
      //     }
      //   });
      // });
      

    })
  }

//   onItemChange(value){
//     console.log(" Value is : ", value );
//  }
}
